<template>
	<div class="user-info__row user-info__account-funds">Доступно средств:
		<span>{{balance}}</span>
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		computed: {
			...mapState({
				balance: state => state.user.balance
			})
		}
	}
</script>
